import { Swiper } from '../lib/swiper';

export function initAllSliders() {
	if (document.body.classList.contains('page-template-tmpl_facilities')) {
		initStoresGallerySwiper();
		initStoresSwiper();
	}
	if (document.body.classList.contains('page-template-tmpl_home')) {
		initHomeSwiper();
		initHomeContentSwiper();
	}
}

function initHomeSwiper() {
	const sliderEl = document.querySelector('.home-featured-swiper');
	if (!sliderEl) return null;
	const homeSwiper = new Swiper(sliderEl, {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		effect: 'fade',
		navigation: {
			nextEl: '.home-swiper-button-next',
			prevEl: '.home-swiper-button-prev',
		},
	});

	return homeSwiper;
}

function initStoresSwiper() {
	const sliderEl = document.querySelector('.store-swiper');
	if (!sliderEl) return null;
	const storesSwiper = new Swiper(sliderEl, {
		slidesPerView: 3,
		spaceBetween: 100,
		loop: false,
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			350: {
				slidesPerView: 2,
				spaceBetween: 40,
			},
			860: {
				slidesPerView: 3,
				spaceBetween: 50,
			},
		},
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
		},
	});

	return storesSwiper;
}
function initStoresGallerySwiper() {
	const sliderEl = document.querySelector('.store-gallery-swiper');
	if (!sliderEl) return null;
	const storesGallerySwiper = new Swiper(sliderEl, {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: false,
		effect: 'fade',
		navigation: {
			nextEl: '.swiper-gallery-button-next',
			prevEl: '.swiper-gallery-button-prev',
		},
	});

	return storesGallerySwiper;
}

function initHomeContentSwiper() {
	const sliderEl = document.querySelector('.home-content-swiper');
	if (!sliderEl) return null;
	const homeContentSwiper = new Swiper(sliderEl, {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		pagination: {
			el: '.home-content-swiper-pagination',
			clickable: true,
		},
	});
	return homeContentSwiper;
}
